import { render } from "./DiningOutlets.vue?vue&type=template&id=de4db212&scoped=true"
import script from "./DiningOutlets.vue?vue&type=script&lang=js"
export * from "./DiningOutlets.vue?vue&type=script&lang=js"

import "./DiningOutlets.vue?vue&type=style&index=0&id=de4db212&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/SIMI-TRAC/SIMI-TRAC-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de4db212"]])

export default __exports__